<!-- Digital Twin Waterway 
Infrastructure Platform -->
<template>
  <div class="dtwin-wateway-intro">
    <div class="wrapper">
      <el-carousel
        indicator-position="inside"
        :loop="true"
        arrow="never"
        :autoplay="true"
        :interval="8000"
        height="382px"
        trigger="click"
        ref="carouse"
        @change="handerChange"
      >
        <el-carousel-item v-for="(item, index) in carouseList" :key="index">
          <aside class="dtwin-wateway-aside">
            <header
              class="aside-hd"
              v-scroll-animate="{
                animation: 'fadeInUp',
              }"
            >
              {{ item.title }}
            </header>
            <p
              class="aside-desc"
              v-scroll-animate="{
                animation: 'fadeInUp',
                delay: 200,
              }"
            >
              {{ item.desc }}
            </p>
            <!-- item.linkUrl -->
            <a class="aside-ft" target="_self" href="javascript:;">
              {{ item.linkLabel }}
            </a>
          </aside>
          <article class="dtwin-wateway-mian">
            <img class="c_img cursor-pointer" :src="item.picUrl" alt="轮播图" />
          </article>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "TwinWaterwayIntro",
  components: {},
  data() {
    return {
      currentPage: 1,
      carouseList: [
        {
          id: 1,
          picUrl: require("@/assets/images/dtwin/twin-wateway-1.png"),
          title: "数字孪生航道基础平台",
          desc: "\u3000\u3000数字孪生航道基础平台，将航段、船闸、护岸、桥梁，河床等进行了模型还原、数据对接、孪生模拟，在航道运行管理、状态监测方面提供了更直观的可视化管理方式。提升了航道管理与服务的智能化水平。",
          linkUrl: "",
          linkLabel: "航道运营监控可视化　>",
        },
        {
          id: 2,
          picUrl: require("@/assets/images/dtwin/twin-wateway-2.png"),
          title: "数字孪生航道基础平台",
          desc: "\u3000\u3000平台借助高精度传感器与三维建模技术，对航道河床的地形地貌、底质状况、冲刷淤积区域进行了精准测绘、模型构建以及动态数据关联。通过实时采集河床的深度变化、沉积物分布等关键数据，并将其直观呈现于孪生模型之上，对河床状态进行全方位、全时段的可视化监测。",
          linkUrl: "",
          linkLabel: "航道河床监测可视化　>",
        },
        {
          id: 3,
          picUrl: require("@/assets/images/dtwin/twin-wateway-3.png"),
          title: "数字孪生航道基础平台",
          desc: "\u3000\u3000运用先进的数字化采集技术，对航道沿线的航标、灯塔、助航设施、通信基站等进行全面的数据采集与模型构建。通过物联网技术，实现这些设施的实时状态数据与数字模型的无缝对接，无论是设施的位置信息、工作参数，还是运行状态，都能在数字孪生模型中精准呈现。",
          linkUrl: "",
          linkLabel: "航道沿线设施可视化　>",
        },
      ],
    };
  },
  computed: {},
  created() {
    console.log("this.carouseList--11", this.carouseList);
  },
  mounted() {},
  methods: {
    handerChange(index) {
      this.currentPage = index + 1;
    },
    handleCurrentChange({ pageIndex }) {
      console.log(`当前页: ${pageIndex}`);
      this.currentPage = pageIndex;
      this.$refs.carouse.setActiveItem(this.currentPage - 1);
    },
  },
};
</script>

<style lang="scss">
.dtwin-wateway-intro {
  width: 100%;
  background: url("~@/assets/images/dtwin/twin-wateway_bg.png") no-repeat center;
  background-size: 100% 564px;
  background-size: cover;
  padding: 64px 0;
  .wrapper {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 382px;

    .dtwin-wateway-aside {
      position: relative;
      flex: 1;
      min-width: 400px;
      margin-right: 40px;
      .aside-hd {
        margin-bottom: 32px;
        width: 280px;
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        line-height: 32px;
        text-align: left;
        font-style: normal;
      }
      .aside-desc {
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.9);

        line-height: 32px;
        text-align: justify;
        font-style: normal;
      }
      .aside-ft {
        position: absolute;
        right: 0;
        bottom: 22px;
        font-weight: 400;
        font-size: 16px;
        color: #bae8fa;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        cursor: default;
        &:hover {
          // opacity: 0.8;
          // text-decoration: underline;
        }
      }
    }
    .dtwin-wateway-mian {
      width: 740px;
      height: 100%;
      img {
        width: 100%;
        height: 360px;
        object-fit: cover;
        box-shadow: 0px 2px 25px 0px rgba(0, 0, 0, 0.5);
      }
    }

    .el-carousel__item {
      display: flex;
      height: 100%;
    }
    .el-carousel__indicators {
      left: 70%;

      .el-carousel__indicator--horizontal {
        padding: 10px 4px 0 4px;
        margin-right: 8px;
        .el-carousel__button {
          width: 24px;
          height: 4px;
          border-radius: 2px;
          transition: all 0.3s;
        }
        &.is-active {
          .el-carousel__button {
            width: 80px;
            background-color: #1fabab;
          }
        }
      }
    }
  }
}
</style>
